var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-sidebar-lotto__filter"},_vm._l((_vm.systemSelectors),function(type){return _c('CustomCheckbox',{key:type.name,staticClass:"nav-sidebar-lotto__filter-option",attrs:{"value":type.selected,"name":type.name,"label":type.name,"translateLabel":false},on:{"valueChanged":_vm.onValueChanged}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f22d9c7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/terminal/app/modules/shared/lotto/SystemFilterContainer.vue
// module id = 2262
// module chunks = 0